/* Mykotheke tema – zajedničko ponašanje: korpa (Shopify Cart API), meni, pretraga, Pilz-Finder, zaglavlje, karta.
   Korpa: /cart/add.js, /cart/change.js, /cart.js. Bonus (automatski popust) računa Shopify; ovdje se samo prikazuje. */
(() => {
  const root = window.Shopify && Shopify.routes ? Shopify.routes.root : "/";
  // valuta tržišta (EUR za AT i DE, CHF za CH): znak dolazi iz teme (window.MK_SHIP.cur)
  const CUR = (window.MK_SHIP && window.MK_SHIP.cur) || "€";
  const LOC = CUR === "CHF" ? "de-CH" : "de-AT"; // CHF: 25.00 (kao cijene iz Shopifyja), EUR: 25,00
  const eur = (c) => (c / 100).toLocaleString(LOC, { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + "\u00a0" + CUR;
  const esc = (s) => String(s ?? "").replace(/[&<>"']/g, (ch) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" })[ch]);
  const ICON = {
    plus: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>',
    check: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg>',
  };

  /* ---------- Bonus i besplatna dostava ----------
     Bonus (automatski popust u shopu, za sva tržišta): 50 € → 3 €, 100 → 7, 200 → 17, 300 → 30.
     Dostava po tržištu: window.MK_SHIP iz snippeta mk-ship (prag i cijena u EUR centima).
     Shopify prag za besplatnu dostavu gleda iznos POSLIJE bonusa (provjereno 2026-10-22: 50,70 € − 3 € bonus = 47,70 € → 5 € dostava;
     55,50 € − 3 € = 52,50 € → gratis). Zato je stvarni prag FREE_AT: najmanji iznos korpe kojem i poslije bonusa ostaje ≥ prag.
     Tržište u drugoj valuti (CH, CHF): iznosi se preračunavaju po Shopify.currency.rate, kao u kasi. */
  const SHIP = window.MK_SHIP || { free: null, wohin: "", same: true };
  const RATE = (window.Shopify && Shopify.currency && parseFloat(Shopify.currency.rate)) || 1;
  const conv = (c) => (SHIP.same ? c : c * RATE);
  const whole = (c) => `${Math.floor(conv(c) / 100)} ${CUR}`; // npr. bonus „3 €“ / „3 CHF“ (c u EUR centima)
  const TIERS = [{ at: 5000, bonus: 300 }, { at: 10000, bonus: 700 }, { at: 20000, bonus: 1700 }, { at: 30000, bonus: 3000 }].map((t) => ({ at: Math.round(conv(t.at)), bonus: t.bonus, cut: Math.round(conv(t.bonus)) }));
  const FREE = SHIP.free ? Math.ceil(conv(SHIP.free) / 100) * 100 : null; // prag zaokružen naviše na cijelu jedinicu
  // iznosi u statičnom tekstu (Liquid ispisuje EUR; za drugu valutu ovdje preračunati)
  if (!SHIP.same) document.querySelectorAll("[data-eur]").forEach((el) => {
    const v = conv(+el.dataset.eur);
    el.textContent = el.hasAttribute("data-up") ? `${Math.ceil(v / 100)} ${CUR}` : el.hasAttribute("data-down") ? `${Math.floor(v / 100)} ${CUR}` : eur(Math.round(v));
  });
  // roba bez bonova: Shopify bon ne broji za bonus ni za besplatnu dostavu (provjereno 2026-10-30, MK-1087: 75 € bon bez bonusa)
  const goods = (c) => (c.items_subtotal_price ?? c.total_price) - c.items.filter((it) => it.gift_card).reduce((a, it) => a + it.final_line_price, 0);
  const tierOf = (s) => TIERS.filter((t) => s >= t.at).pop();
  const bonusFor = (s) => tierOf(s)?.bonus || 0; // EUR centi, za tekst
  const cutFor = (s) => tierOf(s)?.cut || 0; // u valuti korpe, za račun
  const FREE_AT = FREE ? Math.min(...[0, ...TIERS.map((t) => t.cut)].map((b) => FREE + b).filter((x) => cutFor(x) === x - FREE)) : null;
  const shipFree = (s) => !!FREE_AT && s >= FREE_AT;
  // sljedeći cilj: prvo besplatna dostava (ako je ima i nije dostignuta), inače sljedeći bonus
  // (kad je bonus-stepenica do 10 € prije praga za dostavu, oba cilja idu u jednu poruku: „bis Gratisversand und 3 € Bonus“)
  const nextGoal = (s) => {
    const nb = TIERS.find((t) => s < t.at);
    if (FREE_AT && s < FREE_AT) {
      if (nb && nb.at < FREE_AT && FREE_AT - nb.at > Math.round(conv(1000))) return { at: nb.at, ship: false, bonus: nb.bonus };
      return { at: FREE_AT, ship: true, bonus: nb && nb.at <= FREE_AT ? nb.bonus : 0 };
    }
    return nb ? { at: nb.at, ship: false, bonus: nb.bonus } : null;
  };
  const have = (s) => {
    const parts = [];
    if (shipFree(s)) parts.push("Gratisversand");
    const b = bonusFor(s); if (b) parts.push(`${whole(b)} Bonus`);
    return parts.join(" und ");
  };
  const goalText = (s) => {
    const g = nextGoal(s), h = have(s);
    if (!g) return `${h} ${h.includes("und") ? "sind" : "ist"} drin. Das ist der höchste Bonus.`;
    const what = g.ship ? `zum Gratisversand ${SHIP.wohin}${g.bonus ? ` und ${whole(g.bonus)} Bonus` : ""}` : `${whole(g.bonus)} Bonus`;
    // iznad praga, ali bonus ga spušta ispod: objasniti zašto još fali
    const why = g.ship && FREE && s >= FREE ? ` Der Gratisversand gilt ab ${Math.round(FREE / 100)} ${CUR} nach Abzug des Bonus.` : "";
    return `${h ? `${h} ${h.includes("und") ? "sind" : "ist"} drin. ` : ""}Noch <b>${eur(g.at - s)}</b> bis ${what}.${why}`;
  };
  const stripGoal = (s) => {
    const g = nextGoal(s), h = have(s);
    if (!g) return [`${h} sind drin`, `${h} sind drin`];
    const what = g.ship ? `Gratisversand${g.bonus ? ` und ${whole(g.bonus)} Bonus` : ""}` : `${whole(g.bonus)} Bonus`;
    return [`${h ? `${h} ${h.includes("und") ? "sind" : "ist"} drin. ` : ""}Noch <b>${eur(g.at - s)}</b> bis ${what}`, `Noch <b>${eur(g.at - s)}</b> bis ${g.ship ? "Gratisversand" : `${whole(g.bonus)} Bonus`}`];
  };
  // položaj na ljestvama: svaka stepenica (50 / 100 / 200 / 300) je četvrtina širine
  const ladderPos = (s) => {
    const k = TIERS.filter((t) => s >= t.at).length;
    if (k >= TIERS.length) return 100;
    const lo = k ? TIERS[k - 1].at : 0, hi = TIERS[k].at;
    return ((k + (s - lo) / (hi - lo)) / TIERS.length) * 100;
  };

  /* ---------- Korpa ---------- */
  let cart = null;
  try { cart = JSON.parse(document.getElementById("mk-cart-json")?.textContent || "null"); } catch (e) { cart = null; }
  const drawer = document.querySelector("[data-cart-drawer]");
  const views = [...document.querySelectorAll("[data-cart-view]")]; // korpa sa strane i stranica /cart
  const menu = document.querySelector("[data-menu-drawer]");
  let lastFocus = null, undo = null;

  // kratak naslov i marka (isto kao snippets/mk-short-title.liquid i mk-brand.liquid; mijenjati zajedno)
  const SUFFIX = [" / MOONAMAR", " / TYROLER GLÜCKSPILZE", " / Tiroler Glückspilze", " / TIROLER GLÜCKSPILZE", " / Glückspilze", " / Phytopharma", " von Phytopharma", " von TNT Enterprise", " / Phytodent", " / Fungifee", " – Healthcare Products", " – Smaints", " / BOOTCH", " / MY HONEY", " - „Pilze Schöls“", ' - "Pilze Schöls"'];
  const BRANDS = [["moonamar", "MOONAMAR"], ["glückspilze", "Tyroler Glückspilze"], ["gluckspilze", "Tyroler Glückspilze"], ["phytopharma", "Phytopharma"], ["phytodent", "Phytodent"], ["purazell", "Purazell"], ["tnt enterprise", "TNT Enterprise"], ["fungifee", "Fungifee"], ["healthcare products", "Healthcare Products"], ["healthcareproducts", "Healthcare Products"], ["smaints", "Smaints"], ["bootch", "Bootch"], ["mycoffee", "MYCOFFEE"], ["pilze schöls", "Pilze Schöls"], ["pilze schols", "Pilze Schöls"], ["my honey", "My Honey"], ["fungi³", "Mykotheke"], ["selbst zusammenstellen", "Mykotheke"]];
  const shortTitle = (t) => { let s = String(t || ""); SUFFIX.forEach((x) => { s = s.split(x).join(""); }); return s.trim().replace(/,$/, ""); };
  const brandOf = (t) => { const l = String(t || "").toLowerCase(); return (BRANDS.find(([k]) => l.includes(k)) || [])[1] || ""; };

  // svojstva stavke: mješavina („Ingredient 1“ + „Amount 1 (ml)“) kao „Reishi (Ganoderma l.) · 40 ml“; skrivena (_…) se ne prikazuju.
  // Mješavina praha (60 g) upisuje grame („Amount 1 (g)“); starije stavke praha imaju udio od 100 pod „(ml)“, pa se prikazuju kao „25 %“.
  const GIFT = { "Recipient name": "Für", "Recipient email": "An", "Message": "Nachricht", "Send on": "Zustellung am" }; // Shopify svojstva bona za primaoca
  const propsHTML = (p, it = {}) => {
    if (!p) return "";
    const ml = /pulver|\b\d+\s?g\b/i.test(`${it.product_title || ""} ${it.title || ""}`) ? "\u00a0%" : " ml";
    const keys = Object.keys(p).filter((k) => !k.startsWith("_") && p[k] !== "" && p[k] != null);
    if (!keys.length) return "";
    const out = [];
    keys.forEach((k) => {
      const m = k.match(/^Ingredient (\d+)$/);
      if (m) {
        const ak = keys.find((x) => x.startsWith(`Amount ${m[1]} (`)), u = ak ? ak.slice(ak.lastIndexOf("(") + 1, -1) : "ml";
        out.push(`${esc(p[k])} · ${esc((ak && p[ak]) || "?")}${u === "ml" ? ml : `\u00a0${esc(u)}`}`);
      }
      else if (GIFT[k]) out.push(`${GIFT[k]}: ${esc(k === "Send on" ? new Date(p[k] + "T12:00").toLocaleDateString("de-AT") : p[k])}`);
      else if (!/^Amount \d+ \(\w+\)$/.test(k) && !/^Total \(\w+\)$/.test(k)) out.push(`${esc(k)}: ${esc(p[k])}`);
    });
    return `<ul class="props">${out.map((x) => `<li>${x}</li>`).join("")}</ul>`;
  };
  const imgSrc = (u, w) => (u ? `${esc(u)}${u.includes("?") ? "&" : "?"}width=${w}` : "");

  const itemHTML = (it, i) => {
    const name = shortTitle(it.product_title), brand = brandOf(it.product_title);
    const img = it.image ? `<img src="${imgSrc(it.image, 200)}" alt="" width="64" height="64" loading="lazy">` : '<span class="ph"></span>';
    const variant = it.variant_title && !/default title/i.test(it.variant_title) ? `<small>${esc(it.variant_title)}</small>` : "";
    const plan = it.selling_plan_allocation ? `<span class="ck-badge">${esc(it.selling_plan_allocation.selling_plan.name)}</span>` : "";
    const was = it.original_line_price > it.final_line_price ? `<s>${eur(it.original_line_price)}</s>` : "";
    const each = it.quantity > 1 ? `<small>je ${eur(it.final_price)}</small>` : "";
    return `<div class="ck-item" data-line="${i + 1}">
      <a class="ck-img" href="${esc(it.url)}" tabindex="-1" aria-hidden="true">${img}</a>
      <div class="ck-t">${brand ? `<span class="ck-brand">${esc(brand)}</span>` : ""}<a class="ck-name" href="${esc(it.url)}">${esc(name)}</a>${variant}${plan}${propsHTML(it.properties, it)}
        <div class="ck-ctl">
          <span class="ck-qty"><button type="button" data-qty="${it.quantity - 1}" aria-label="${esc(name)}: eins weniger">−</button><output aria-label="Menge">${it.quantity}</output><button type="button" data-qty="${it.quantity + 1}" aria-label="${esc(name)}: eins mehr">+</button></span>
          <button type="button" class="ck-rm" data-qty="0">Entfernen<span class="visually-hidden">: ${esc(name)}</span></button>
        </div>
      </div>
      <div class="ck-p"><b class="price">${eur(it.final_line_price)}</b>${was}${each}</div>
    </div>`;
  };
  const ladderHTML = (s) => {
    const g = nextGoal(s);
    const rungs = TIERS.map((t) => `<li class="${s >= t.at ? "on" : g && !g.ship && g.at === t.at ? "next" : ""}"><b>${whole(t.bonus)}</b><span>ab ${Math.ceil(t.at / 100)} ${CUR}</span></li>`).join("");
    return `<div class="ck-lad"><p class="ck-lad-t">${goalText(s)}</p>
      <div class="ck-rail" aria-hidden="true"><span class="ck-rail-fill" style="width:${ladderPos(s)}%"></span>${TIERS.map((t, i) => `<i class="${s >= t.at ? "on" : ""}" style="left:${((i + 1) / TIERS.length) * 100}%"></i>`).join("")}</div>
      <ol class="ck-rungs" aria-label="Bonusstufen">${rungs}</ol></div>`;
  };
  const rowsHTML = () => {
    const s = cart.items_subtotal_price ?? cart.total_price;
    const g = goods(cart);
    // /cart.js daje popust direktno, a /cart/change.js ga umotava: { amount, discount_application: { title, … } }
    const disc = (cart.cart_level_discount_applications || []).map((x) => { const d = x.discount_application || x; return `<div class="ck-row is-bonus"><span>${/bonus/i.test(d.title) ? "Bonus" : esc(d.title)}</span><span>− ${eur(d.total_allocated_amount)}</span></div>`; }).join("");
    const fee = SHIP.fee ? Math.round(conv(SHIP.fee)) : null;
    const known = !!FREE_AT && fee != null;
    const free = shipFree(g);
    const ship = cart.requires_shipping === false ? `<div class="ck-row is-free"><span>Versand</span><span>entfällt, per E-Mail</span></div>` : known ? `<div class="ck-row${free ? " is-free" : ""}"><span>Versand ${esc(SHIP.wohin)}</span><span>${free ? "Gratis" : eur(fee)}</span></div>` : `<div class="ck-row"><span>Versand</span><span>an der Kasse</span></div>`;
    const total = cart.total_price + (cart.requires_shipping !== false && known && !free ? fee : 0);
    const tax = g <= 0 ? "Gutschein, ohne MwSt." : SHIP.country === "CH" ? "Bei Lieferung in die Schweiz können Einfuhrabgaben anfallen." : "inkl. MwSt.";
    return `<div class="ck-row"><span>Zwischensumme</span><span>${eur(s)}</span></div>${disc}${ship}
      <div class="ck-row is-total"><span>${known ? "Gesamt" : "Summe"}<small>${tax}</small></span><b class="price">${eur(total)}</b></div>`;
  };

  // prijedlog do sljedećeg cilja: Shopify preporuke za prvi proizvod u korpi; samo proizvodi bez izbora, koji cilj stvarno
  // dostižu i nisu mnogo skuplji od onoga što fali (najviše 40 € više); najviše dva
  const recCache = new Map();
  let fillTok = 0;
  const recsFor = async (pid) => {
    if (!recCache.has(pid)) recCache.set(pid, fetch(`${root}recommendations/products.json?product_id=${pid}&limit=10`).then((r) => r.json()).then((j) => j.products || []).catch(() => []));
    return recCache.get(pid);
  };
  const drawFill = async () => {
    const boxes = views.map((v) => v.querySelector("[data-cart-fill]")).filter(Boolean);
    const tok = ++fillTok;
    const s = cart && goods(cart);
    const g = cart && cart.item_count && s > 0 ? nextGoal(s) : null;
    if (!g) { boxes.forEach((b) => (b.innerHTML = "")); return; }
    const gap = g.at - s;
    const inCart = new Set(cart.items.map((it) => it.product_id));
    const list = (await recsFor(cart.items[0].product_id)).filter((p) => p.available && p.variants.length === 1 && !p.requires_selling_plan && !inCart.has(p.id) && !/selbst-zusammenstellen/.test(p.handle) && p.price >= gap && p.price <= gap + Math.round(conv(4000)))
      .sort((a, b) => a.price - b.price).slice(0, 2);
    if (tok !== fillTok) return; // korpa se u međuvremenu promijenila
    const goal = g.ship ? "der Gratisversand" : `der ${whole(g.bonus)} Bonus`;
    boxes.forEach((b) => (b.innerHTML = list.length ? `<section class="ck-fill" aria-label="Vorschläge">
      <p>Mit einem davon ist ${goal} drin:</p>
      ${list.map((p) => { const n = shortTitle(p.title); return `<div class="ck-fill-row"><a href="${esc(p.url)}">${p.featured_image ? `<img src="${imgSrc(p.featured_image, 120)}" alt="" width="44" height="44" loading="lazy">` : ""}<span>${esc(n)}</span></a><b class="price">${eur(p.price)}</b><button class="add" type="button" data-add="${p.variants[0].id}" aria-label="${esc(n)} in den Warenkorb">${ICON.plus}</button></div>`; }).join("")}
    </section>` : ""));
  };

  const fetchCart = async () => { cart = await (await fetch(root + "cart.js", { headers: { Accept: "application/json" } })).json(); render(); return cart; };
  const bump = () => document.querySelectorAll("[data-cart-count]").forEach((b) => { b.classList.remove("bump"); void b.offsetWidth; b.classList.add("bump"); });

  const add = async (items) => {
    const r = await fetch(root + "cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items }) });
    if (!r.ok) { const e = await r.json().catch(() => ({})); throw new Error(e.description || "add failed"); }
    undo = null;
    await fetchCart(); bump(); openCart();
  };
  const setBusy = (on) => views.forEach((v) => v.classList.toggle("is-busy", on));
  const change = async (line, quantity) => {
    const it = cart && cart.items[line - 1];
    setBusy(true);
    try {
      const r = await fetch(root + "cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line, quantity }) });
      if (!r.ok) throw new Error();
      // uklonjena stavka: „Rückgängig“ je vraća s istom količinom, pretplatom i svojstvima (mješavina)
      undo = quantity === 0 && it ? { name: shortTitle(it.product_title), item: { id: it.variant_id, quantity: it.quantity, ...(it.selling_plan_allocation ? { selling_plan: it.selling_plan_allocation.selling_plan.id } : {}), ...(it.properties && Object.keys(it.properties).length ? { properties: it.properties } : {}) } } : null;
      cart = await r.json(); render();
    } catch (e) { await fetchCart().catch(() => {}); }
    finally { setBusy(false); }
  };

  const setOpen = (el, cls, on) => {
    if (!el) return;
    document.body.classList.toggle(cls, on);
    el.setAttribute("aria-hidden", on ? "false" : "true");
    if (on) { lastFocus = document.activeElement; el.focus(); }
    else if (lastFocus && document.contains(lastFocus)) lastFocus.focus();
    document.querySelectorAll(`[aria-controls="${el.id}"]`).forEach((b) => b.setAttribute("aria-expanded", on));
  };
  const openCart = () => { setOpen(menu, "menu-open", false); setOpen(drawer, "cart-open", true); };
  const closeAll = () => { if (document.body.classList.contains("cart-open")) setOpen(drawer, "cart-open", false); if (document.body.classList.contains("menu-open")) setOpen(menu, "menu-open", false); };

  document.addEventListener("click", async (e) => {
    const addBtn = e.target.closest("[data-add]");
    if (addBtn) {
      e.preventDefault();
      addBtn.disabled = true;
      const was = addBtn.innerHTML, icon = addBtn.classList.contains("add");
      try { await add([{ id: +addBtn.dataset.add, quantity: +(addBtn.dataset.qty || 1) }]); addBtn.classList.add("done"); if (icon) addBtn.innerHTML = ICON.check; setTimeout(() => { addBtn.classList.remove("done"); addBtn.innerHTML = was; }, 1600); }
      catch (err) { location.href = addBtn.closest(".card")?.querySelector("a.title")?.href || root + "cart"; }
      addBtn.disabled = false;
      return;
    }
    if (e.target.closest("[data-open-cart]") && drawer) { e.preventDefault(); if (!cart) await fetchCart(); openCart(); return; }
    if (e.target.closest("[data-open-menu]") && menu) { setOpen(menu, "menu-open", true); return; }
    if (e.target.closest("[data-close-cart], [data-close-menu]")) closeAll();
    const q = e.target.closest(".ck-item [data-qty]");
    if (q) change(+q.closest(".ck-item").dataset.line, +q.dataset.qty);
    if (e.target.closest("[data-undo]") && undo) { const u = undo.item; undo = null; setBusy(true); try { await add([u]); } catch (err) { await fetchCart(); } finally { setBusy(false); } }
    if (e.target.closest("[data-checkout].is-off")) e.preventDefault();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeAll(); });

  const render = () => {
    if (!cart) return;
    const s = goods(cart);
    document.querySelectorAll("[data-strip-goal]").forEach((g) => {
      g.closest(".strip")?.classList.toggle("has-goal", s > 0);
      if (s > 0) { const [l, k] = stripGoal(s); g.innerHTML = `<span class="l">${l}</span><span class="s">${k}</span>`; }
    });
    document.querySelectorAll("[data-cart-count]").forEach((b) => { b.textContent = cart.item_count; b.hidden = cart.item_count === 0; });
    const n = cart.item_count;
    const undoHTML = undo ? `<div class="ck-undo" role="status">„${esc(undo.name)}“ entfernt. <button type="button" data-undo>Rückgängig</button></div>` : "";
    views.forEach((v) => {
      v.classList.toggle("is-empty", !n);
      v.querySelectorAll("[data-cart-n]").forEach((el) => (el.textContent = n ? `(${n})` : ""));
      const items = v.querySelector("[data-cart-items]");
      if (items) items.innerHTML = undoHTML + cart.items.map(itemHTML).join("");
      v.querySelector("[data-cart-empty]")?.toggleAttribute("hidden", !!n);
      v.querySelector("[data-cart-foot]")?.toggleAttribute("hidden", !n);
      const lad = v.querySelector("[data-cart-ladder]");
      if (lad) lad.innerHTML = n && s > 0 ? ladderHTML(s) : "";
      const rows = v.querySelector("[data-cart-rows]");
      if (rows) rows.innerHTML = n ? rowsHTML() : "";
      const co = v.querySelector("[data-checkout]");
      if (co) { co.toggleAttribute("aria-disabled", !n); co.classList.toggle("is-off", !n); }
      const live = v.querySelector("[data-cart-live]");
      if (live && live.dataset.n !== String(n) + cart.total_price) { if (live.dataset.n) live.textContent = n ? `Warenkorb: ${n} Artikel, ${eur(cart.total_price)}` : "Der Warenkorb ist leer."; live.dataset.n = String(n) + cart.total_price; }
    });
    drawFill();
    document.dispatchEvent(new CustomEvent("mk:cart"));
  };
  render();

  window.MK = { add, openCart, fetchCart, eur, goods, freeAt: FREE_AT, get cart() { return cart; } };

  /* ---------- Glavni meni (iz admina): paneli na prelaz mišem, klik i tastaturu ----------
     Unutrašnje stranice: otvara se tek kad miš zastane 300 ms na stavci, a zatvara 400 ms nakon izlaska
     (NN/g, Baymard: bez slučajnog otvaranja dok miš prelazi preko trake). Ako je neki panel već otvoren, prelaz je odmah. */
  const items = [...document.querySelectorAll("[data-nav-item]")];
  const OPEN = 300, CLOSE = 400;
  const setItem = (it, on) => {
    it.classList.toggle("open", on); it.querySelector(".nav-top").setAttribute("aria-expanded", on);
    // slike u skrivenim pregledima (druga kolekcija, kartice kategorija) učitati čim se panel otvori, da ne bljesnu prazne
    if (on) it.querySelectorAll(".mega img[loading='lazy']").forEach((im) => (im.loading = "eager"));
  };
  const anyOpen = () => items.some((it) => it.classList.contains("open"));
  const closeNav = (except) => items.forEach((it) => it !== except && setItem(it, false));
  const fine = matchMedia("(hover: hover) and (pointer: fine)");
  items.forEach((it) => {
    let tOpen = 0, tClose = 0;
    // mišem je panel već otvoren prelazom, pa klik ne smije da ga zatvori; na dodir i tastaturom klik otvara i zatvara
    it.querySelector(".nav-top").addEventListener("click", (e) => { clearTimeout(tOpen); const on = fine.matches && e.detail > 0 ? true : !it.classList.contains("open"); closeNav(it); setItem(it, on); });
    it.addEventListener("pointerenter", () => {
      if (!fine.matches) return;
      it.classList.add("warm"); // panel se iscrta skriven, da slike stignu prije otvaranja (mk.css: content-visibility)
      clearTimeout(tClose); clearTimeout(tOpen);
      const go = () => { closeNav(it); setItem(it, true); };
      if (anyOpen()) go(); else tOpen = setTimeout(go, OPEN);
    });
    it.addEventListener("pointerleave", () => { if (!fine.matches) return; clearTimeout(tOpen); tClose = setTimeout(() => setItem(it, false), CLOSE); });
    it.addEventListener("focusin", () => it.classList.add("warm"));
    it.addEventListener("focusout", (e) => { if (!it.contains(e.relatedTarget)) setItem(it, false); });
  });
  document.addEventListener("click", (e) => { if (!e.target.closest("[data-nav-item]")) closeNav(); });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    const open = items.find((it) => it.classList.contains("open"));
    if (open) { setItem(open, false); open.querySelector(".nav-top").focus(); }
  });

  /* paneli menija: kartica ili pregled desno prati stavku pod mišem ili fokusom
     PRODUKTE: [data-card] link → .mp-card s istim ključem; mali meniji: [data-key] red → [data-pane] (proizvodi kolekcije) */
  document.querySelectorAll("[data-mega]").forEach((m) => {
    const cards = [...m.querySelectorAll(".mp-preview [data-card]")];
    const panes = [...m.querySelectorAll("[data-pane]")];
    const showCard = (key) => {
      const c = cards.find((x) => x.dataset.card === key); if (!c) return;
      cards.forEach((x) => (x.hidden = x !== c));
      m.querySelectorAll(".mp-main [data-card]").forEach((a) => a.classList.toggle("is-on", a.dataset.card === key));
    };
    const showPane = (key) => {
      const p = panes.find((x) => x.dataset.pane === key); if (!p) return;
      panes.forEach((x) => (x.hidden = x !== p));
      m.querySelectorAll("[data-key]").forEach((a) => a.classList.toggle("is-on", a.dataset.key === key));
    };
    m.querySelectorAll(".mp-main [data-card]").forEach((a) => ["pointerenter", "focus"].forEach((ev) => a.addEventListener(ev, () => showCard(a.dataset.card))));
    m.querySelectorAll("[data-key]").forEach((a) => ["pointerenter", "focus"].forEach((ev) => a.addEventListener(ev, () => showPane(a.dataset.key))));
    if (cards.length && !cards.some((x) => !x.hidden)) cards[0].hidden = false;
    const p0 = panes.find((x) => !x.hidden); if (p0) m.querySelector(`[data-key="${p0.dataset.pane}"]`)?.classList.add("is-on");
  });

  /* ---------- Zaglavlje: sjena kad stranica krene ---------- */
  const header = document.querySelector("[data-header]");
  const onScroll = () => header && header.classList.toggle("is-stuck", window.scrollY > 40);
  window.addEventListener("scroll", onScroll, { passive: true }); onScroll();

  /* ---------- Pretraga s prijedlozima (Shopify Predictive Search) ---------- */
  const sForm = document.querySelector("[data-search]");
  if (sForm) {
    const input = sForm.querySelector("input[name=q]"), list = sForm.querySelector("[data-suggest]");
    let timer = 0, ctrl = null;
    const show = async () => {
      const q = input.value.trim();
      if (q.length < 2) { list.innerHTML = ""; input.setAttribute("aria-expanded", "false"); return; }
      ctrl?.abort(); ctrl = new AbortController();
      try {
        const url = `${root}search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last`;
        const data = await (await fetch(url, { signal: ctrl.signal })).json();
        const ps = data.resources?.results?.products || [];
        list.innerHTML = ps.length
          ? `<div class="k">Produkte</div>` + ps.map((p) => `<a href="${esc(p.url)}"><img src="${esc(p.image || "")}${p.image ? (p.image.includes("?") ? "&" : "?") + "width=96" : ""}" alt="" width="44" height="44"><span>${esc(p.title)}</span><b class="price">${eur(Math.round(parseFloat(p.price) * 100))}</b></a>`).join("") + `<a class="all" href="${root}search?q=${encodeURIComponent(q)}">Alle Ergebnisse für „${esc(q)}“</a>`
          : `<div class="k">Keine Produkte für „${esc(q)}“. Versuchen Sie einen anderen Pilz oder rufen Sie uns an.</div>`;
        input.setAttribute("aria-expanded", "true");
      } catch (err) { /* prekinuto novim upitom */ }
    };
    input.addEventListener("input", () => { clearTimeout(timer); timer = setTimeout(show, 160); });
    input.addEventListener("focus", show);
  }

  /* ---------- Pilz-Finder ---------- */
  const fBox = document.querySelector("[data-finder]");
  if (fBox) {
    const DATA = JSON.parse(document.querySelector("[data-finder-data]")?.textContent || "[]");
    const MUSH = { reishi: "Reishi", igelstachelbart: "Igelstachelbart", chaga: "Chaga", cordyceps: "Cordyceps", shiitake: "Shiitake", zunderschwamm: "Zunderschwamm", mandelpilz: "Mandelpilz", maitake: "Maitake", coriolus: "Coriolus", austernpilz: "Austernpilz" };
    const FORM = { alle: "Alle Formen", extrakte: "Extrakte", kapseln: "Kapseln", pulver: "Pulver", tee: "Tee & Kaffee", frisch: "Frisch" };
    const URLS = { alle: "/collections/all", extrakte: "/collections/vitalpilz-ekstrakte", kapseln: "/collections/kapseln", pulver: "/collections/pulver", tee: "/collections/tee-kaffee", frisch: "/collections/frische-pilze-grow-kits" };
    const COUNTS = {};
    DATA.forEach(([m, fs]) => { COUNTS[m] = COUNTS[m] || {}; fs.forEach((f) => (COUNTS[m][f] = (COUNTS[m][f] || 0) + 1)); });
    const mSel = fBox.querySelector("[data-m]"), fSel = fBox.querySelector("[data-f]"), go = fBox.querySelector("[data-go]"), out = fBox.querySelector("output");
    // pilzovi s najviše proizvoda prvi
    const keys = Object.keys(MUSH).filter((k) => COUNTS[k]).sort((a, b) => COUNTS[b].alle - COUNTS[a].alle);
    mSel.innerHTML = keys.map((k) => `<option value="${k}">${MUSH[k]}</option>`).join("");
    const draw = () => {
      const m = mSel.value;
      let f = fSel.value || "alle";
      if (!COUNTS[m][f]) f = "alle";
      fSel.innerHTML = Object.entries(FORM).map(([k, v]) => {
        const n = COUNTS[m][k] || 0;
        return `<option value="${k}" ${n ? "" : "disabled"}>${k === "alle" ? v : `${v} (${n})`}</option>`;
      }).join("");
      fSel.value = f;
      const n = COUNTS[m][f];
      go.textContent = `${n} ${n === 1 ? "Produkt" : "Produkte"} ansehen`;
      out.textContent = `${n} ${n === 1 ? "Produkt" : "Produkte"}: ${MUSH[m]}, ${FORM[f]}`;
      fBox.action = URLS[f];
    };
    mSel.addEventListener("change", draw);
    fSel.addEventListener("change", draw);
    if (keys.length) draw(); else fBox.closest(".finder").hidden = true;
  }

  /* ---------- Karta: put od U3 se iscrta kad sekcija dođe na ekran ---------- */
  const visit = document.querySelector(".visit");
  document.documentElement.classList.add("js-anim");
  if (visit) new IntersectionObserver(([e], o) => { if (e.isIntersecting) { visit.classList.add("in-view"); o.disconnect(); } }, { threshold: 0.4 }).observe(visit);
})();

/* ---------- Vlastiti padajući izbor umjesto sistemskog (select[data-mk-select]) ----------
   Obrazac W3C „Select-Only Combobox“: dugme (role=combobox) + lista (role=listbox) s aria-activedescendant.
   Pravi <select> ostaje u stranici (skriven) i nosi vrijednost: forma, „change“ i ostali kod rade kao prije.
   Tastatura: ↓ ↑ Home End otvaraju i kreću se, Enter/Razmak biraju, Escape zatvara, Tab bira i ide dalje, slovo skače na opciju. */
(() => {
  let uid = 0;
  const enhance = (sel) => {
    if (sel._mk) return;
    const id = `mks-${++uid}`;
    const wrap = document.createElement("span");
    wrap.className = "mk-sel-wrap";
    sel.parentNode.insertBefore(wrap, sel);
    wrap.append(sel);
    sel.classList.add("mk-sel-native");
    sel.tabIndex = -1;
    sel.setAttribute("aria-hidden", "true");
    const btn = document.createElement("button");
    btn.type = "button";
    btn.className = "mk-sel";
    btn.id = id;
    btn.setAttribute("role", "combobox");
    btn.setAttribute("aria-haspopup", "listbox");
    btn.setAttribute("aria-expanded", "false");
    btn.setAttribute("aria-controls", id + "-list");
    // natpis: <label> oko izbora (npr. „Pilz“) ili label[for]
    const lab = sel.closest("label");
    const labText = lab ? (lab.querySelector("span")?.textContent || "").trim() : "";
    if (labText) btn.setAttribute("aria-label", labText);
    const list = document.createElement("ul");
    list.className = "mk-list";
    list.id = id + "-list";
    list.setAttribute("role", "listbox");
    list.tabIndex = -1;
    if (labText) list.setAttribute("aria-label", labText);
    list.hidden = true;
    wrap.append(btn, list);
    // klik na <label> ne smije otvarati sistemski izbor
    if (lab) lab.addEventListener("click", (e) => { if (e.target === lab || e.target.tagName === "SPAN") { e.preventDefault(); btn.focus(); } });

    let active = -1, typed = "", typedT = 0;
    const opts = () => [...sel.options];
    const render = () => {
      const o = opts();
      list.innerHTML = o.map((op, i) => `<li role="option" id="${id}-o${i}" data-i="${i}" aria-selected="${op.selected}"${op.disabled ? ' aria-disabled="true"' : ""}><span>${op.textContent}</span><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M5 12.5l4.5 4.5L19 7.5"/></svg></li>`).join("");
      btn.textContent = sel.selectedOptions[0]?.textContent || "";
      btn.disabled = sel.disabled;
    };
    const setActive = (i) => {
      active = i;
      list.querySelectorAll("[role=option]").forEach((li) => li.classList.toggle("is-active", +li.dataset.i === i));
      if (i >= 0) { btn.setAttribute("aria-activedescendant", `${id}-o${i}`); list.children[i]?.scrollIntoView({ block: "nearest" }); }
      else btn.removeAttribute("aria-activedescendant");
    };
    const move = (from, dir) => { const o = opts(); let i = from; do { i += dir; } while (i >= 0 && i < o.length && o[i].disabled); return i >= 0 && i < o.length ? i : from; };
    const open = () => {
      if (!list.hidden || sel.disabled) return;
      document.querySelectorAll(".mk-list:not([hidden])").forEach((l) => l !== list && l._close && l._close());
      render(); list.hidden = false; btn.setAttribute("aria-expanded", "true"); wrap.classList.add("open");
      // otvori prema gore ako dole nema mjesta
      const r = btn.getBoundingClientRect(), need = Math.min(list.scrollHeight, 320) + 12;
      wrap.classList.toggle("up", innerHeight - r.bottom < need && r.top > need);
      setActive(sel.selectedIndex);
    };
    const close = (focus) => { if (list.hidden) return; list.hidden = true; btn.setAttribute("aria-expanded", "false"); wrap.classList.remove("open"); setActive(-1); if (focus) btn.focus(); };
    list._close = () => close(false);
    const choose = (i) => {
      const o = opts()[i]; if (!o || o.disabled) return;
      const changed = sel.selectedIndex !== i;
      sel.selectedIndex = i; render();
      if (changed) { sel.dispatchEvent(new Event("input", { bubbles: true })); sel.dispatchEvent(new Event("change", { bubbles: true })); }
    };
    const typeahead = (ch) => {
      clearTimeout(typedT); typed += ch.toLowerCase(); typedT = setTimeout(() => (typed = ""), 600);
      const o = opts(), start = list.hidden ? sel.selectedIndex : active;
      for (let k = 1; k <= o.length; k++) { const i = (start + k) % o.length; if (!o[i].disabled && o[i].textContent.trim().toLowerCase().startsWith(typed)) return i; }
      return -1;
    };

    btn.addEventListener("click", () => (list.hidden ? open() : close(true)));
    btn.addEventListener("keydown", (e) => {
      const isOpen = !list.hidden, o = opts();
      switch (e.key) {
        case "ArrowDown": e.preventDefault(); if (!isOpen) open(); else setActive(move(active, 1)); break;
        case "ArrowUp": e.preventDefault(); if (!isOpen) open(); else setActive(move(active, -1)); break;
        case "Home": if (isOpen) { e.preventDefault(); setActive(move(-1, 1)); } break;
        case "End": if (isOpen) { e.preventDefault(); setActive(move(o.length, -1)); } break;
        case "Enter": case " ": e.preventDefault(); if (!isOpen) open(); else { choose(active); close(true); } break;
        case "Escape": if (isOpen) { e.preventDefault(); e.stopPropagation(); close(true); } break;
        case "Tab": if (isOpen) { choose(active); close(false); } break;
        default:
          if (e.key.length === 1 && !e.metaKey && !e.ctrlKey && !e.altKey) {
            const i = typeahead(e.key);
            if (i >= 0) { if (isOpen) setActive(i); else choose(i); }
          }
      }
    });
    list.addEventListener("mousedown", (e) => e.preventDefault()); // fokus ostaje na dugmetu
    list.addEventListener("click", (e) => { const li = e.target.closest("[role=option]"); if (!li || li.getAttribute("aria-disabled")) return; choose(+li.dataset.i); close(true); });
    list.addEventListener("pointermove", (e) => { const li = e.target.closest("[role=option]"); if (li && !li.getAttribute("aria-disabled") && +li.dataset.i !== active) setActive(+li.dataset.i); });
    btn.addEventListener("blur", () => setTimeout(() => { if (!wrap.contains(document.activeElement)) close(false); }, 0));
    document.addEventListener("pointerdown", (e) => { if (!wrap.contains(e.target)) close(false); });
    // opcije koje mijenja drugi kod (npr. Finder) i vrijednost postavljena iz koda
    new MutationObserver(render).observe(sel, { childList: true, subtree: true, attributes: true, characterData: true });
    sel.addEventListener("change", render);
    sel._mk = { render, open, close };
    render();
  };
  const run = () => document.querySelectorAll("select[data-mk-select]").forEach(enhance);
  run();
  window.MK = Object.assign(window.MK || {}, { enhanceSelects: run });
})();

/* Bonus objašnjen (snippets/mk-bonus): dugme s data-bonus-open otvara dijalog; zatvara X, klik pored ili Esc */
(() => {
  const d = document.getElementById("mk-bonus");
  if (!d || typeof d.showModal !== "function") return;
  let from = null;
  document.addEventListener("click", (e) => {
    const o = e.target.closest("[data-bonus-open]");
    if (o) { from = o; d.showModal(); return; }
    if (d.open && (e.target.closest("[data-bonus-close]") || e.target === d)) d.close();
  });
  d.addEventListener("close", () => { if (from) from.focus(); });
})();

/* Rok za Božić (snippets/mk-weihnacht): faza po današnjem datumu u Beču, jer stranica može doći iz keša.
   Element [data-xmas] nosi datume; njegovi dijelovi [data-ph="vor|nach|aus"] se pokazuju po fazi.
   ?datum=GGGG-MM-DD u adresi pokazuje drugi dan (pregled prije sezone). */
(() => {
  const q = new URLSearchParams(location.search).get("datum");
  const day = q && /^\d{4}-\d{2}-\d{2}$/.test(q) ? q : new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Vienna" }).format(new Date());
  document.querySelectorAll("[data-xmas]").forEach((el) => {
    const { start, frist, ende } = el.dataset;
    if (!frist) return;
    const ph = day < start || day > ende ? "aus" : day <= frist ? "vor" : "nach";
    el.dataset.phase = ph;
    el.querySelectorAll("[data-ph]").forEach((s) => { if (s.closest("[data-xmas]") === el) s.hidden = s.dataset.ph !== ph; });
  });
})();

/* Grüner Freitag (snippets/mk-gruen): traka i napomena u korpi samo 27.–30. 11., po danu u Beču (stranica može biti iz keša).
   Dok traje, traka pokazuje Grüner Freitag umjesto obične poruke ([data-strip-normal]). Stranica [data-gf] dobija fazu vor/jetzt/nach.
   ?datum=GGGG-MM-DD u adresi pokazuje drugi dan. */
(() => {
  const q = new URLSearchParams(location.search).get("datum");
  const day = q && /^\d{4}-\d{2}-\d{2}$/.test(q) ? q : new Intl.DateTimeFormat("en-CA", { timeZone: "Europe/Vienna" }).format(new Date());
  document.querySelectorAll("[data-gf-strip]").forEach((el) => {
    const an = day >= el.dataset.von && day <= el.dataset.bis;
    el.hidden = !an;
    const normal = el.parentElement?.querySelector(":scope > [data-strip-normal]");
    if (normal) normal.hidden = an;
  });
  document.querySelectorAll("[data-gf]").forEach((el) => {
    const { von, bis } = el.dataset;
    const ph = day < von ? "vor" : day <= bis ? "jetzt" : "nach"; // stranica: najava, akcija, zahvala
    el.dataset.phase = ph;
    el.querySelectorAll("[data-gf-ph]").forEach((s) => { s.hidden = !s.dataset.gfPh.split(" ").includes(ph); });
  });
})();
